import {type TaskChecklist} from '@domain/hroc-checklists'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'
import {useEffect} from 'react'
import {useNavigate} from 'react-router'

import {TasksApiPath} from '../../consts'
import {type HProduceTask} from '../../types'
import {handleTasksError as handleError} from '../../utils'

export const TaskChecklistsQueryKey = 'task-checklists'

type TaskChecklistsParams = Pick<HProduceTask, 'externalId' | 'plantId'>

export const useTaskChecklists = (
  {plantId, externalId: taskId}: TaskChecklistsParams,
  options?: Omit<UseQueryOptions<TaskChecklist[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const navigate = useNavigate()
  const path = `${TasksApiPath.HROC_CHECKLISTS}/${plantId}/checklists/for-task/${taskId}`

  const query = useQuery<TaskChecklist[], AxiosError>({
    queryKey: [TaskChecklistsQueryKey, plantId, taskId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<TaskChecklist[]>(path, {signal})
      return response.data
    },
    ...options
  })

  useEffect(() => {
    if (query.error) {
      handleError(query.error, navigate)
    }
  }, [query.error, navigate])

  return query
}
